import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { ContactCTA } from '../components/ContactCTA';
import { useSeo } from '../hooks/useSeo';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card, CardContent } from '../components/ui/Card';
import { Users, Heart, Target, Newspaper, ExternalLink, ArrowRight, ShieldCheck } from 'lucide-react';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
export function BDE() {
  useSeo({
    title: 'Vie étudiante et BDE Zillenium',
    description: "Projets solidaires, événements et vie de promo : découvrez le Bureau des Étudiants de Zillenium Alternance en images et en vidéos. Une école où l'alternance rime avec engagement.",
    path: '/bde'
  });
  return <div className="flex flex-col w-full" data-id="element-802" data-mp="31beyf06rwgkd">
      <PageHeader title="Le BDE Zillenium" subtitle="Un bureau des étudiants engagé, formateur et fédérateur. Découvrez une vie étudiante dynamique et solidaire." data-id="element-803" data-mp="36a8aqpabq1iy" />

      <div className="flex flex-col w-full" data-id="element-804" data-mp="3mw2defk9693j">
        {/* Intro & Projets */}
        <section className="py-24 bg-muted relative overflow-hidden" data-id="element-805" data-mp="3mtyc85dqno6y">
          <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-806" data-mp="5erkotfmxg32" />
          <div className="container max-w-6xl mx-auto relative z-10" data-id="element-807" data-mp="38vzwownollpv">
            <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-808" data-mp="38y41dgtemor7">
              <SectionHeading title="Association BDE Zillenium" centered className="mb-6" data-id="element-809" data-mp="33xyeedy2xqfg" />
              <p className="text-lg text-muted-foreground leading-relaxed mb-8" data-id="element-810" data-mp="3dv47frq97rib">
                Le Bureau des Étudiants est un espace clé de la vie étudiante.
                Il permet aux apprenants de se rencontrer, de s'engager et de
                construire ensemble des projets concrets qui développent
                l'esprit d'équipe, la prise d'initiative et le sens des
                responsabilités.
              </p>
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 inline-block text-left" data-id="element-811" data-mp="3qxniu04kzf24">
                <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-4" data-id="element-812" data-mp="3vyusk4qaaobf">
                  Des projets incroyables se préparent :
                </h3>
                <div className="flex flex-wrap gap-3 justify-center sm:justify-start" data-id="element-813" data-mp="339e41i5sbrkh">
                  <Badge className="bg-brand-orange text-white hover:bg-[#E67E22] border-none px-4 py-2 text-sm" data-id="element-814" data-mp="387pdhrs64026">
                    Maraude solidaire
                  </Badge>
                  <Badge className="bg-primary text-white hover:bg-primary-dark border-none px-4 py-2 text-sm" data-id="element-815" data-mp="3c7pspen3cfaa">
                    Tournoi inter-écoles
                  </Badge>
                  <Badge className="bg-primary-dark text-white hover:bg-primary border-none px-4 py-2 text-sm" data-id="element-816" data-mp="2ki4iubmnjed2">
                    Sensibilisation au don du sang
                  </Badge>
                  <Badge className="bg-brand-orange text-white hover:bg-[#E67E22] border-none px-4 py-2 text-sm" data-id="element-817" data-mp="2gzxan4rmi1sm">
                    Bal de promo
                  </Badge>
                </div>
              </div>
            </div>

            {/* Association loi 1901 */}
            <div className="max-w-3xl mx-auto mb-20" data-id="element-818" data-mp="231h3xdtrgbah">
              <Card className="border-none shadow-md bg-white overflow-hidden" data-id="element-819" data-mp="2330kz6n8qqdb">
                <div className="h-1.5 w-full bg-primary" data-id="element-820" data-mp="1y2w4vhq8vxnm" />
                <CardContent className="p-6 sm:p-8 flex flex-col sm:flex-row items-start gap-5" data-id="element-821" data-mp="1tamg450v93mx">
                  <div className="w-12 h-12 shrink-0 bg-lavande rounded-xl flex items-center justify-center" data-id="element-822" data-mp="1ob05m3cfa1ht">
                    <ShieldCheck className="w-6 h-6 text-primary" data-id="element-823" data-mp="1kb7r7a0cl14j" />
                  </div>
                  <div data-id="element-824" data-mp="1fbd2nd41onmn">
                    <h3 className="font-bold text-lg text-primary-dark mb-2" data-id="element-825" data-mp="1fak3oybbv2f2">
                      Association déclarée sous la loi 1901
                    </h3>
                    <p className="text-muted-foreground leading-relaxed text-sm" data-id="element-826" data-mp="3adqa75xxl6s5">
                      Le Bureau des Étudiants de Zillenium est une association
                      régie par la loi du 1<sup data-id="element-827" data-mp="30oq6j98hhn7m">er</sup> juillet 1901, déclarée
                      à la sous-préfecture de Sens.
                    </p>
                    <div className="flex flex-wrap gap-x-8 gap-y-2 mt-4 text-sm" data-id="element-828" data-mp="35mhyu4d1jbcc">
                      <span data-id="element-829" data-mp="2rn8r7t2whpjz">
                        <span className="text-muted-foreground" data-id="element-830" data-mp="2rm75muo9dko0">N° RNA : </span>
                        <span className="font-semibold text-primary-dark" data-id="element-831" data-mp="2vqewoyi6vcpe">
                          W893007506
                        </span>
                      </span>
                      <span data-id="element-832" data-mp="2mofei2vfu2kv">
                        <span className="text-muted-foreground" data-id="element-833" data-mp="2mpqgpy98j29v">
                          Siège social :{' '}
                        </span>
                        <span className="font-semibold text-primary-dark" data-id="element-834" data-mp="fw4sz5o3z8pf">
                          25 rue Gabriel Cortel, 89300 Joigny
                        </span>
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-835" data-mp="20efg19cq5iwe">
              <Card className="border-none shadow-xl bg-primary text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-836" data-mp="2f6pmk3kbqkz6">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-837" data-mp="2o5ukb7o2aaaa">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-838" data-mp="2o7ntouq278lz">
                    <Users className="w-8 h-8 text-lavande animate-soft-bounce" data-id="element-839" data-mp="2y3iftzthrlti" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-840" data-mp="2t5h0npz6s6nb">
                    SE RETROUVER
                  </h3>
                  <p className="text-lavande leading-relaxed" data-id="element-841" data-mp="yqwh5gmlqh5i">
                    Des actions solidaires et citoyennes portées par les
                    étudiants
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl bg-brand-orange text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-842" data-mp="1shos0p0me0l8">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-843" data-mp="1xhtbmnwtrbfo">
                  <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-844" data-mp="22cqh5kuwb2nt">
                    <Heart className="w-8 h-8 text-white animate-soft-pulse" data-id="element-845" data-mp="2bega4v4fe9np" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-846" data-mp="2g79g1mbmro1d">
                    S'AMUSER
                  </h3>
                  <p className="text-white/90 leading-relaxed" data-id="element-847" data-mp="2l4jdnp96b60a">
                    Une vie étudiante dynamique, conviviale et engagée
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl bg-primary-dark text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-848" data-mp="2v1ea82lvywbx">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-849" data-mp="egspnkdtqmlm">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-850" data-mp="9hft27x5i15u">
                    <Target className="w-8 h-8 text-lavande animate-soft-float" data-id="element-851" data-mp="4l8vp3itlxzi" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-852" data-mp="128hbchw54ctl">
                    CRÉER
                  </h3>
                  <p className="text-lavande leading-relaxed" data-id="element-853" data-mp="sgbk5adppzfg">
                    Des projets associatifs concrets, de la conception à la
                    réalisation
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* BDE Press Article */}
            <div className="mb-16" data-id="element-854" data-mp="1g5w68255xcsy">
              <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden bg-white" data-id="element-855" data-mp="1g4utlt8i0i94">
                <div className="h-2 w-full bg-brand-orange" data-id="element-856" data-mp="ogqhr86xbb75" />
                <CardContent className="p-8 sm:p-10 flex flex-col md:flex-row items-center gap-8" data-id="element-857" data-mp="tacuf0d37f2y">
                  <div className="w-20 h-20 shrink-0 bg-brand-orange/10 rounded-2xl flex items-center justify-center" data-id="element-858" data-mp="fjg1t9j5uxvw">
                    <Newspaper className="w-10 h-10 text-brand-orange" data-id="element-859" data-mp="khhjpr4uor5s" />
                  </div>
                  <div className="flex-1 text-center md:text-left" data-id="element-860" data-mp="187lo40pv4uxu">
                    <Badge className="bg-slate-100 text-slate-600 hover:bg-slate-200 border-none mb-4" data-id="element-861" data-mp="1c7e06negtj7y">
                      Dans la presse • L'Yonne Républicaine
                    </Badge>
                    <h3 className="font-bold text-xl md:text-2xl text-primary-dark mb-4 leading-tight" data-id="element-862" data-mp="136xxvh9gki4o">
                      À Joigny, les étudiants lancent des journées de partage
                      pour redynamiser La Madeleine et lutter contre la
                      précarité étudiante
                    </h3>
                    <p className="text-muted-foreground mb-6" data-id="element-863" data-mp="3gd49g2dhpdxc">
                      Une belle mise en lumière de l'engagement de nos étudiants
                      et du BDE Zillenium dans la presse locale.
                    </p>
                    <Button asChild variant="outline" className="group border-slate-200 hover:border-brand-orange hover:text-brand-orange" data-id="element-864" data-mp="3pcreqz9cb3vo">
                      <a href="https://www.lyonne.fr/joigny-89300/actualites/pour-redynamiser-la-madeleine-et-lutter-contre-la-precarite-des-etudiants-vont-initier-des-journees-de-partage-a-joigny_14964196/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2" data-id="element-865" data-mp="2sp4j33k3bpja">
                        Lire l'article complet
                        <ExternalLink className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" data-id="element-866" data-mp="290lt4jr9g83j" />
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* BDE Video Gallery */}
            <div className="mb-16" data-id="element-867" data-mp="159pw897qx4lq">
              <SectionHeading title="La vie du BDE en images" centered className="mb-10" data-id="element-868" data-mp="116tbabuqgwem" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-869" data-mp="w99ub46ni5iz">
                {['https://www.instagram.com/reel/DbfjvGXOCvH/embed', 'https://www.instagram.com/reel/DbgRvI4t3t0/embed', 'https://www.instagram.com/p/DbbFE78jUEc/embed', 'https://www.instagram.com/reel/DZ0K5pFNFOZ/embed', 'https://www.instagram.com/reel/DZsokh-OUor/embed', 'https://www.instagram.com/p/DZrtdYhIr7B/embed', 'https://www.instagram.com/p/DZPobROjY_C/embed', 'https://www.instagram.com/reel/DY7lQJ5uSwb/embed', 'https://www.instagram.com/reel/DY5HdDCO9pL/embed'].map((url, i) => <div key={i} className="bg-white p-3 rounded-[2rem] shadow-lg border border-slate-100 hover:-translate-y-1 hover:shadow-xl transition-all duration-300" data-id="element-870" data-mp="2t6pcti2o47on" data-mpi={i}>
                    <div className="relative rounded-[1.5rem] overflow-hidden bg-slate-100 aspect-[9/16]" data-id="element-871" data-mp="21gb03p6e51ek">
                      <iframe src={url} title={`Vidéo BDE ${i + 1}`} className="absolute inset-0 w-full h-full" frameBorder="0" scrolling="no" allowTransparency={true} data-id="element-872" data-mp="25dyyj27alcb7"></iframe>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-873" data-mp="2pzoctfbnlep2">
              <Button size="lg" className="bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 shadow-xl w-full sm:w-auto" asChild data-id="element-874" data-mp="2l0brx04cehp4">
                <a href="https://www.instagram.com/bdezillenium/" target="_blank" rel="noopener noreferrer" data-id="element-875" data-mp="2us986la7jzup">
                  Suivre le BDE sur Instagram
                </a>
              </Button>
            </div>
          </div>
        </section>

        {/* CTA Candidater */}
        <section className="py-24 bg-primary-dark text-white relative overflow-hidden" data-id="element-876" data-mp="2fzxlfmie3ft7">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary rounded-full blur-[100px] opacity-40 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-877" data-mp="2b5bebvjcc9ex" />
          <div className="container text-center max-w-4xl mx-auto relative z-10" data-id="element-878" data-mp="3mhue5d7j0gmn">
            <h2 className="font-heading text-4xl md:text-5xl font-extrabold mb-8 tracking-tight" data-id="element-879" data-mp="3uybgqsgggprn">
              Envie de rejoindre l'aventure ?
            </h2>
            <p className="text-lavande text-xl mb-12 leading-relaxed font-medium" data-id="element-880" data-mp="3l16xb0dzv8ej">
              Intégrez une école dynamique où l'alternance rime avec engagement,
              solidarité et réussite.
            </p>
            <Button size="lg" className="bg-white hover:bg-lavande text-primary-dark text-lg px-10 py-7 shadow-xl group" asChild data-id="element-881" data-mp="hjyhem2tuimg">
              <Link to="/candidater" className="flex items-center" data-id="element-882" data-mp="7uybsjttkoza">
                Candidater maintenant
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-883" data-mp="ct88iyv6zxn0" />
              </Link>
            </Button>
          </div>
        </section>

        {/* Contact direct */}
        <section className="py-24 bg-white" data-id="element-884" data-mp="15ac92bhi2fgi">
          <div className="container max-w-6xl mx-auto" data-id="element-885" data-mp="15bdm2li2tc0v">
            <ContactCTA title="Envie de nous rejoindre ? Appelez-nous" subtitle="Un conseiller vous explique les formations, l'alternance et la vie étudiante en quelques minutes. Vous pouvez aussi nous écrire sur WhatsApp." variant="light" action={{
            label: 'Découvrir nos formations',
            to: '/formations'
          }} data-id="element-886" data-mp="3ctvybtgwqu7l" />
          </div>
        </section>
      </div>
    </div>;
}